import { Template } from "typings";
import produce from "immer";
import { ServerState } from "../ServerState";
import { LoadTemplatesSuccessAction, LoadTemplatesFailureAction } from "./action";

export interface State extends ServerState<Template>
{
}

const initialState: State = {
    byId: {}
};

type Actions = LoadTemplatesSuccessAction | LoadTemplatesFailureAction;

const reducer = (state = initialState, action: Actions): State => produce(state, draft =>
{
    if (action.type === "LOAD_TEMPLATES_SUCCESS")
    {
        const { templates } = action;
        for (const template of templates)
        {
            draft.byId[template.id] = template;
        }
    }
});

export const getTemplates = (state: State) => Object.keys(state.byId).map(key => state.byId[key]);

export const getTemplatesByType = (state: State, type: string) => getTemplates(state).filter(template => template.type === type);

export const getTemplateById = (state: State, id: string) => state.byId[id];

export default reducer;


// WEBPACK FOOTER //
// ./src/state/schema/index.ts